var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('article',{staticClass:"deteil",domProps:{"innerHTML":_vm._s(_vm.detail)}})])}
var staticRenderFns = []

export { render, staticRenderFns }